import React from 'react';
import {
  FormControl,
  Box,
  FormHelperText,
  TextField,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

import THIRD_PARTY_TYPES from '@/components/jobs/JobForm/thirdPartyTypes';

export default function InputUriField({
  value,
  inputType,
  error,
  setValue,
  setError,
  setChanged,
  edit,
  projectDatastores,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);

    if (inputType === THIRD_PARTY_TYPES.REGIONAL.value) {
      setError(false);
    } else {
      const uriTest = Object.values(THIRD_PARTY_TYPES).find(
        (type) => type.value === inputType
      )?.uriTest;
      if (uriTest) {
        const valid = uriTest.test(newValue);
        setError(!valid);
      }
    }
  };

  const selected_type = Object.values(THIRD_PARTY_TYPES).find(
    (type) => type.value === inputType
  );
  const placeholder = selected_type ? selected_type.uriExample : '';

  if (inputType === THIRD_PARTY_TYPES.REGIONAL.value && projectDatastores) {
    return (
      <Box>
        <FormControl fullWidth>
          <InputLabel id='input-uri-label'>Datastore</InputLabel>
          <Select
            labelId='input-uri-label'
            id='input_uri'
            value={value || ''}
            label='Datastore'
            aria-describedby='input-uri-helper-text'
            onChange={handleChange}
            disabled={edit}
          >
            {projectDatastores.map((datastore) => (
              <MenuItem key={datastore.id} value={datastore.id}>
                {datastore.name}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText id='input-uri-helper-text'>
            Select the datastore
          </FormHelperText>
        </FormControl>
      </Box>
    );
  }

  if (!inputType) {
    return null;
  }

  return (
    <Box>
      <FormControl fullWidth>
        <TextField
          label='Input storage path'
          id='input_uri'
          aria-describedby='input-uri-helper-text'
          variant='outlined'
          fullWidth
          placeholder={placeholder}
          onChange={handleChange}
          error={Boolean(error)}
          value={value || ''}
          disabled={edit}
        />
        {error ? (
          <FormHelperText id='input-uri-helper-text'>
            Storage Path Invalid
          </FormHelperText>
        ) : (
          <FormHelperText id='input-uri-helper-text'>
            Enter the input storage path
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

